import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useMemo } from 'react';
import {
  getDefaultSortBySuffix,
  getSearchSortContext,
  isTcDirectorySearchPage,
} from './defaultSortBy';

export const useSearchSortContext = () => {
  const { sitecoreContext } = useSitecoreContext();
  return useMemo(() => getSearchSortContext(sitecoreContext), [sitecoreContext]);
};

/**
 * Shared helper hook for memoized default full sort value derived from Sitecore page context.
 */
export const useDefaultSortByValue = (): string | undefined => {
  const { defaultSortByValue } = useSearchSortContext();
  return defaultSortByValue;
};

/**
 * Shared helper hook for memoized default sort suffix derived from Sitecore page context.
 */
export const useSortBySuffix = (): string | undefined => {
  const { defaultSortBySuffix } = useSearchSortContext();
  return defaultSortBySuffix;
};

/**
 * Returns a stable flag that indicates whether routing should use TC Directory mapping.
 */
export const useTcDirectoryRoutingFlag = (): boolean => {
  const { useTcDirectoryRouteState } = useSearchSortContext();
  return useTcDirectoryRouteState;
};

export { getDefaultSortBySuffix, isTcDirectorySearchPage };
